// Shared UA patterns for the phone-browser app interstitial. The pre-paint boot
// script is built from these same sources (see views/v2/interstitialBoot.ts) with
// their flags, so the shipped client detection and this tested function cannot drift.
export const PHONE_UA = {
  // Crawlers and lab tools (Googlebot Smartphone, bingbot, Lighthouse/PSI) carry a
  // phone UA but must NOT get the overlay: mobile-first indexing would index it and
  // every PageSpeed run would measure it, not the landing.
  bot: /bot|crawl|spider|slurp|bingpreview|lighthouse|pagespeed|headlesschrome/i,
  // Native Savannah app UA carries an `iOS/` or `Android/` token (see resolveDevicePlatform,
  // which matches case-insensitively — keep this in lockstep).
  native: /(?:^|\s)(?:iOS|Android)\//i,
  ipad: /iPad/,
  iphone: /iPhone|iPod/,
  android: /Android/,
  mobile: /Mobile/,
};

/**
 * Classify a browser user-agent as a PHONE browser for the app-download
 * interstitial. Only real mobile-browser phones qualify: crawlers/lab tools and
 * the native Savannah app are excluded, and tablets/desktops are excluded because
 * the interstitial is a phone-only nudge. Returns null for anything that must see
 * the site directly.
 */
export function phoneBrowserPlatform(ua: string): "ios" | "android" | null {
  if (PHONE_UA.bot.test(ua)) return null;
  if (PHONE_UA.native.test(ua)) return null;
  if (PHONE_UA.ipad.test(ua)) return null;
  if (PHONE_UA.iphone.test(ua)) return "ios";
  if (PHONE_UA.android.test(ua) && PHONE_UA.mobile.test(ua)) return "android";
  return null;
}
